/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../types.generated";
export type FindRelevantFoodActivitiesQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type FindRelevantFoodActivitiesQuery = {
  findRelevantFoodActivities: Array<
    Pick<
      Types.EventActivity,
      | "category"
      | "created_at"
      | "end_time"
      | "event_id"
      | "id"
      | "location"
      | "name"
      | "restrictions"
      | "start_time"
      | "updated_at"
      | "slug"
      | "restrictions_string"
    > & {
      food_line?: Types.Maybe<
        Pick<
          Types.FoodLine,
          | "id"
          | "approx_length"
          | "service_speed"
          | "status"
          | "updated_at"
          | "event_activity_id"
          | "updated_by_user_id"
        >
      >;
    }
  >;
};

export const FindRelevantFoodActivitiesDocument = gql`
  query FindRelevantFoodActivities {
    findRelevantFoodActivities {
      category
      created_at
      end_time
      event_id
      id
      location
      name
      restrictions
      start_time
      updated_at
      slug
      restrictions_string
      food_line {
        id
        approx_length
        service_speed
        status
        updated_at
        event_activity_id
        updated_by_user_id
      }
    }
  }
`;

/**
 * __useFindRelevantFoodActivitiesQuery__
 *
 * To run a query within a React component, call `useFindRelevantFoodActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindRelevantFoodActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindRelevantFoodActivitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindRelevantFoodActivitiesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    FindRelevantFoodActivitiesQuery,
    FindRelevantFoodActivitiesQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    FindRelevantFoodActivitiesQuery,
    FindRelevantFoodActivitiesQueryVariables
  >(FindRelevantFoodActivitiesDocument, baseOptions);
}
export function useFindRelevantFoodActivitiesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FindRelevantFoodActivitiesQuery,
    FindRelevantFoodActivitiesQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    FindRelevantFoodActivitiesQuery,
    FindRelevantFoodActivitiesQueryVariables
  >(FindRelevantFoodActivitiesDocument, baseOptions);
}
export type FindRelevantFoodActivitiesQueryHookResult = ReturnType<
  typeof useFindRelevantFoodActivitiesQuery
>;
export type FindRelevantFoodActivitiesLazyQueryHookResult = ReturnType<
  typeof useFindRelevantFoodActivitiesLazyQuery
>;
export type FindRelevantFoodActivitiesQueryResult =
  ApolloReactCommon.QueryResult<
    FindRelevantFoodActivitiesQuery,
    FindRelevantFoodActivitiesQueryVariables
  >;
